// NightClub005.js
import React from 'react';
import './Alt.css'; // Import your additional CSS

const NightClub005 = () => {

  const imageUrl ='https://lh5.googleusercontent.com/p/AF1QipPUUnYLcknDVXoQ2FILkLwO_rja07JfXqVuiUMO=w122-h92-k-no';

  return (
    <div className="container">
      <div className="post">
        <div className="title-overlay">서울 이태원클럽 오프더레코드</div> {/* Explicitly specify the title here */}
        <img src={imageUrl} alt="서울 이태원클럽 오프더레코드"/>
      </div>
    </div>
  );
};

export default NightClub005;
